import { styled } from '@linaria/react'
import React, { type FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { Typography } from './Typography'
import { colors } from '../styles/colors'
import FireIcon from '../svgr/Fire'

export const TimeRemaining: FC<{
  minutes?: number
  hours?: number
  days?: number
  showIcon?: boolean
  className?: string
}> = ({ minutes = 0, hours = 0, days = 0, showIcon = false, className }) => {
  const getTimeLeftMessage = () => {
    if (days > 0) {
      return (
        <FormattedMessage
          id="timeRemaining.days"
          defaultMessage="Осталось {days} д {hours} ч"
          values={{ days, hours }}
        />
      )
    }
    if (hours > 0) {
      return (
        <FormattedMessage
          id="timeRemaining.hours"
          defaultMessage="Осталось {hours} ч {minutes} мин"
          values={{ hours, minutes }}
        />
      )
    }
    if (minutes > 0) {
      return (
        <FormattedMessage
          id="timeRemaining.minutes"
          defaultMessage="Осталось {minutes} мин"
          values={{ minutes }}
        />
      )
    }

    return (
      <FormattedMessage
        id="timeRemaining.finished"
        defaultMessage="Время истекло"
      />
    )
  }

  return (
    <TextContainer
      className={className}
      fontSize={10}
      fontWeight={400}
      color={colors.white}
    >
      {showIcon && <FireIcon />}
      {getTimeLeftMessage()}
    </TextContainer>
  )
}

const TextContainer = styled(Typography)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`
